import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { LinkContainer, IfPermitted, ShareButton, Spinner } from "components/common";
import { Button, ButtonToolbar } from "components/bootstrap";
import { getPathnameWithoutId } from "util/URLUtils";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useLocation from "routing/useLocation";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import EntityShareModal from "components/permissions/EntityShareModal";
import SecurityRoutes from "security/Routes";
import TeamsDomain from "../../domainActions/TeamsDomain";
const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const _onDelete = (team, setDeleting) => {
  let confirmMessage = `Do you really want to delete team "${team.name}"?`;
  if (team.users.size >= 1) {
    confirmMessage += `

It is still assigned to ${team.users.size} users.`;
  }
  if (window.confirm(confirmMessage)) {
    setDeleting(true);
    TeamsDomain.delete(team).then(() => {
      setDeleting(false);
    });
  }
};
const EditActions = ({ team, readOnly }) => {
  const [showShareModal, setShowShareModal] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const sendTelemetry = useSendTelemetry();
  const { pathname } = useLocation();
  if (readOnly) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: [`team:edit:${team.id}`, `team_users:edit:${team.id}`], anyPermissions: true }, /* @__PURE__ */ React.createElement(LinkContainer, { to: SecurityRoutes.TEAMS.EDIT(team.id) }, /* @__PURE__ */ React.createElement(Button, { id: `edit-user-${team.id}`, bsSize: "xs", title: `Edit team ${team.name}` }, "Edit"))), /* @__PURE__ */ React.createElement(
    ShareButton,
    {
      bsSize: "xs",
      title: "Manage",
      entityId: team.id,
      entityType: "team",
      onClick: () => setShowShareModal(true)
    }
  ), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: [`team:delete:${team.id}`] }, /* @__PURE__ */ React.createElement(
    Button,
    {
      id: `delete-user-${team.id}`,
      onClick: () => {
        sendTelemetry(TELEMETRY_EVENT_TYPE.TEAM.DELETED, {
          app_pathname: getPathnameWithoutId(pathname),
          app_section: "teams-actions",
          app_action_value: "team-delete"
        });
        _onDelete(team, setDeleting);
      },
      bsStyle: "danger",
      bsSize: "xs",
      title: `Delete team ${team.name}`
    },
    deleting ? /* @__PURE__ */ React.createElement(Spinner, { text: "Deleting", delay: 0 }) : "Delete"
  ))), showShareModal && /* @__PURE__ */ React.createElement(
    EntityShareModal,
    {
      entityId: team.id,
      entityType: "team",
      entityTitle: team.name,
      description: "Search for a User or Team to add as collaborator on this Team.",
      onClose: () => setShowShareModal(false)
    }
  ));
};
const ActionsCell = ({ team, readOnly }) => /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(ActionsWrapper, null, /* @__PURE__ */ React.createElement(EditActions, { team, readOnly })));
export default ActionsCell;
